import React from 'react';
import { Calculator, Home, Car, TrendingUp, Landmark, DollarSign, FileText, Wallet, Clock, Percent } from 'lucide-react';
import { ToolCard } from '../components/ToolCard';
const tools = [{
  title: 'Mortgage Calculator',
  description: 'Calculate monthly mortgage payments for US, UK, and Australia',
  icon: Home,
  href: '/financial/mortgage-calculator'
}, {
  title: 'EMI Calculator',
  description: 'Calculate EMI with detailed amortization schedule',
  icon: Calculator,
  href: '/financial/emi-calculator'
}, {
  title: 'Home Loan EMI Calculator',
  description: 'Calculate EMI for home loans in India',
  icon: Landmark,
  href: '/financial/home-emi-calculator'
}, {
  title: 'Vehicle Loan EMI Calculator',
  description: 'Calculate EMI for vehicle loans in India',
  icon: Car,
  href: '/financial/vehicle-emi-calculator'
}, {
  title: 'SIP Returns Calculator',
  description: 'Calculate returns on Systematic Investment Plans',
  icon: TrendingUp,
  href: '/financial/sip-calculator'
}, {
  title: 'FD/RD Calculator',
  description: 'Calculate Fixed Deposit and Recurring Deposit returns',
  icon: Wallet,
  href: '/financial/fd-calculator'
}, {
  title: 'Rent vs Buy Calculator',
  description: 'Compare renting vs buying a property',
  icon: FileText,
  href: '/financial/rent-vs-buy'
}, {
  title: 'Stamp Duty Calculator',
  description: 'Calculate stamp duty for India and UK',
  icon: Percent,
  href: '/financial/stamp-duty'
}, {
  title: 'Down Payment Planner',
  description: 'Plan your down payment savings',
  icon: DollarSign,
  href: '/financial/down-payment'
}, {
  title: 'Salary to Hourly Converter',
  description: 'Convert annual salary to hourly rate',
  icon: Clock,
  href: '/financial/salary-converter'
}, {
  title: 'Tip Calculator',
  description: 'Calculate tips and split bills (US)',
  icon: Calculator,
  href: '/financial/tip-calculator'
}];
export function FinancialPage() {
  return <div className="container mx-auto px-4 py-8" data-id="element-381">
      <div className="mb-8" data-id="element-382">
        <h1 className="text-4xl font-bold mb-2" data-id="element-383">Financial Calculators</h1>
        <p className="text-muted-foreground" data-id="element-384">
          Powerful calculators for mortgages, loans, investments, and more
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-385">
        {tools.map(tool => <ToolCard key={tool.href} {...tool} data-id="element-386" />)}
      </div>
    </div>;
}